module.exports = __webpack_public_path__ + "img/ZIL.c335c9bd.svg";